import { useEffect, useCallback, useRef, useState } from "react";
import { Grid } from "@material-ui/core";
import Box from "@mui/material/Box";
import { styleCollaboratorTab as style } from "./styleSheet";
import { formatter } from "../../../../helpers/formatoMoneda";
import { removeAccents } from "../../../../helpers/RemoveAccents";


interface Props<T> {
    initState: Array<T>;
    setState: (a: T[]) => void;
    label?: string;
    fields?: Array<string>;
    width?: number;
    updatePaginationObj?: (paginationObj: any) => any;
    getData?: (paginationObj: any) => Promise<any>;
    paginationObj?: any;
    customSearch?: any;
}

const SearcherTable = <T extends Object>({
    initState,
    setState,
    label = "Buscar",
    fields = [],
    width = 420,
    updatePaginationObj,
    getData,
    paginationObj = {},
    customSearch,
}: Props<T>) => {
    const [text, setText] = useState("");

    const getRows = useCallback(
        async (searchText: string) => {
            let dataFiltered;

            if (searchText === "") {
                dataFiltered = initState;
            } else {
                dataFiltered = initState.filter((e) => {
                    const value: { [unit: string]: any } = e;
                    let itemData = "";

                    (fields.length > 0 ? fields : Object.keys(e)).forEach((field) => {
                        if (value[field] && typeof value[field] === "string") {
                            //itemData += `${value[field].toUpperCase()} `;
                            itemData += `${removeAccents(value[field].toUpperCase())} `;
                        }
                    });

                    return itemData.includes(searchText.toUpperCase());
                });
            }          
            //setState([...dataFiltered]); // Asegurar que se usa un nuevo array
            setState(
                dataFiltered.map((x: any) => ({
                  ...x,
                  progress: x.progress
                    ? `${x.progress} / ${(
                        (parseFloat(x.progress || "0") / parseInt(x.metricObjective, 10)) *
                        100
                      ).toFixed(2)}`
                    : "0",
                  metricObjective:
                    x.extraChar === "$"
                      ? `${formatter(x.metricObjective)}`
                      : `${x.metricObjective}${x.extraChar}`,
                  weight: `${x.weight}`,
                }))
              );
              
        },
        [initState, fields, setState]
    );

    const handleChange = (text: string) => {
        setText(text);

        if (customSearch) {
            customSearch(text);
            return;
        }

        if (updatePaginationObj) {
            updatePaginationObj({ searchTerm: text });
        }

        getRows(text);
    };

    // useRef para evitar ejecución inicial del useEffect
    const initialRender = useRef(true);

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
            return;
        }

        if (!customSearch) {
            getRows(text);
        }
    }, [text]); // Solo se ejecuta cuando cambia `text`

    // Asegurar que se filtra si cambia `initState`
    useEffect(() => {
        getRows(text);
    }, [initState]); 

    return (
        <Grid item>
            <Box>
                <Grid container direction="row" style={{ ...style.containerSearcher, width: width }}>
                    <Grid item>
                        <input
                            style={{ ...style.inputSearcher, width: width - 100 }}
                            className="collaboratorTab__searcher"
                            placeholder={label}
                            value={text} // Asegura que el input esté controlado
                            onChange={(e) => handleChange(removeAccents(e.target.value))}
                        />
                    </Grid>

                    <Grid item style={{ width: "20px", padding: "0 20px 0 40px", color: "#7f7f81", fontWeight: "bold" }}>
                        <img src="/assets/icons/icono-buscar.svg" alt="Buscar" />
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default SearcherTable;
